module.exports = __webpack_public_path__ + "static/media/bjarni.c8da3378.png";